import { __decorate, __metadata } from "tslib";
import { UseRestraints } from '@core/shared/restraints';
import { IdItemModel, Default, MinLength, Expose, MinLengthStripHtml, AllowHtml, EditorDefinition, ItemModelDefinition, CrudEndpoints, ItemModelProp, ModelId } from '@core/shared/model';
import { NotificationRestraints } from './notification.restraints';
let NotificationItem = /*#__PURE__*/(() => {
  let NotificationItem = class NotificationItem extends IdItemModel {
    // Alias | optional | Most items have a name to make them identifyable by humans.
    // @Expose()
    // @Default('')
    // alias:string;
    toString() {
      return "Benachrichtigung " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], NotificationItem.prototype, "creationDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Number)], NotificationItem.prototype, "ownerId", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", String)], NotificationItem.prototype, "type", void 0);
  __decorate([Expose(), Default(''), MinLength(3), __metadata("design:type", String)], NotificationItem.prototype, "name", void 0);
  __decorate([Expose(), Default(''), MinLengthStripHtml(10), AllowHtml(), __metadata("design:type", String)], NotificationItem.prototype, "content", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], NotificationItem.prototype, "notifyByEmail", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Array)], NotificationItem.prototype, "recipients", void 0);
  NotificationItem = __decorate([EditorDefinition('create', ['name', 'content', 'notifyByEmail'], {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/notifications'
  }), UseRestraints(NotificationRestraints), ItemModelDefinition({
    texts: {
      item: 'Benachrichtigung',
      items: 'Benachrichtigungen'
    }
  }), ModelId("NotificationItem") // auto-generated by generate-model-ids
  ], NotificationItem);
  return NotificationItem;
})();
export { NotificationItem };